import { memo, useEffect } from "react";
import { GlobalLoaderRemover } from "../../generic";
import { Button, Link } from "../../ui";

import Maintenance from "./images/maintance.svg";

import styles from "./styles.module.scss";

export const GlobalErrorBanner = memo<{ supportLink?: string }>(({ supportLink = "/support" }) => {
  useEffect(() => {
    document.body.style.setProperty("--background-color", "var(--gray-96-color)");
  }, []);

  return (
    <GlobalLoaderRemover>
      <div className={styles.root}>
        <img className={styles.image} src={Maintenance} alt="Maintenance" />
        <h1>Oops! Something went wrong</h1>
        <p>
          {"Please contact technical support at "}
          <Link
            component={"a"}
            href="mailto:support@tecorien.com"
            className={styles.link}
          >
            support@tecorien.com
          </Link>
          <br />
          {"or you can get live support using this "}
          <Link
            component={"a"}
            className={styles.link}
            href={supportLink}
            rel={"noopener noreferrer"}
            target={"_blank"}
          >
            link
          </Link>
        </p>
        <Button className={styles.button} onClick={() => window.location.reload()}>
          Refresh page
        </Button>
      </div>
    </GlobalLoaderRemover>
  );
});

export default GlobalErrorBanner;